function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.4 14.3a4.5 4.5 0 018.097 2.542l-.705-.628a.5.5 0 00-.665.747l1.583 1.411a.5.5 0 00.706-.04l1.412-1.584a.5.5 0 10-.747-.666l-.587.66A5.5 5.5 0 0011.6 13.7a.5.5 0 00.8.6zM10.506 17.259l-.587.659a.5.5 0 11-.747-.666l1.412-1.583a.5.5 0 01.706-.041l1.583 1.411a.5.5 0 01-.665.747l-.705-.629A4.5 4.5 0 0019.6 19.7a.5.5 0 01.8.6 5.5 5.5 0 01-9.894-3.042z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.574 5.336A3 3 0 0115.07 4h6.86a3 3 0 012.496 1.336L25.536 7H28a3 3 0 013 3v14a3 3 0 01-3 3H4a3 3 0 01-3-3V10a3 3 0 013-3h7.465l1.11-1.664zM15.07 6a1 1 0 00-.832.445l-1.11 1.664A2 2 0 0111.466 9H4a1 1 0 00-1 1v14a1 1 0 001 1h24a1 1 0 001-1V10a1 1 0 00-1-1h-2.465a2 2 0 01-1.664-.89l-1.11-1.665A1 1 0 0021.93 6h-6.86z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 4a1 1 0 000 2h3a1 1 0 100-2H6z",
  fill: "currentColor"
})));